import React from "react";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { FaMicrophone } from "react-icons/fa";
import MicRecorder from "mic-recorder-to-mp3";
import { useChatActions } from "../../../../../hooks/useChatActions";
import { useLocalStorage } from "../../../../../hooks/useLocalStorage";
import { storageKeys } from "../../../../../constants/storageKeys";
import initialSettings from "../../../../../constants/settings.json";
import Cookies from "js-cookie";

const recorder = new MicRecorder({ bitRate: 128 });

const RecordButton = () => {
  const isLoading = useSelector((state) => state.isLoading);
  const { handleStartRecording, handleStopRecording } = useChatActions();

  const [baseURL] = useLocalStorage(
    storageKeys.LLM_API_URL,
    JSON.parse(initialSettings.localStorage.LLM_API_URL)
  );

  const handleToggleRecording = () => {
    if (isLoading.recorder) {
      handleStopRecording(recorder);
    } else {
      handleStartRecording(recorder);
    }
  };

  const isBaseURLOfficial = baseURL.startsWith("https://api.openai.com");
  const isDisabled =
    isLoading.checkerManager ||
    isLoading.user ||
    !isBaseURLOfficial ||
    !Cookies.get("apiKey") ||
    Cookies.get("sessionKey");

  return (
    <Button
      variant={isLoading.recorder ? "danger" : "dark"}
      size="lg"
      className="chat-button"
      onClick={handleToggleRecording}
      disabled={isDisabled}
      title={
        !isBaseURLOfficial
          ? "Voice input only works with the official OpenAI API"
          : ""
      }
    >
      <FaMicrophone />
    </Button>
  );
};

export default RecordButton;
